export const DASS = [
  "1. Achei difícil me acalmar",
  "2. Senti minha boca seca",
  "3. Não consegui vivenciar nenhum sentimento positivo",
  "4. Tive dificuldade em respirar em alguns momentos (ex. respiração ofegante, falta de ar, sem ter feito nenhum esforço físico)",
  "5. Achei difícil ter iniciativa para fazer as coisas",
  "6. Tive a tendência de reagir de forma exagerada às situações",
  "7. senti tremores (ex. nas mãos)",
  "8. Senti que estava sempre nervoso",
  "9. Preocupei-me com situações em que eu pudesse entrar em pânico e parecesse ridículo (a)",
  "10. Senti que não tinha nada a desejar",
  "11. Senti-me agitado",
  "12. Achei difícil relaxar",
  "13. Senti-me depressivo (a) e sem ânimo",
  "14. Fui intolerante com as coisas que me impediam de continuar o que eu estava fazendo",
  "15. Senti que ia entrar em pânico",
  "16. Não consegui me entusiasmar com nada",
  "17. Senti que não tinha valor como pessoa",
  "18. Senti que estava um pouco emotivo/sensível demais",
  "19. Sabia que meu coração estava alterado mesmo não tendo feito nenhum esforço físico (ex. aumento da frequência cardíaca, disritmia cardíaca)",
  "20. Senti medo sem motivo",
  "21. Senti que a vida não tinha sentido",
];
